import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";

import curri from "../../constants/enum/curriSum";
import DataVerify from "../../components/verify/dataVerify";
const VerifyContext = React.createContext({});

const Verify = () => {
  const [keyStatus, setKeyStatus] = useState("start");
  const [lavelList, setLavelList] = useState<string[]>([]);
  const [form, setForm] = useState<{
    type: string;
    year: string;
  }>({ type: "", year: "" });

  const [reCheck, setReCheck] = useState(false);
  const [curriList, setCurriList] = useState<
    {
      id: number;
      level: string;
      degreeName: string;
      name: string;
      shortName: string;
    }[]
  >([]);

  const findSchema = Yup.object().shape({
    type: Yup.string().required("เลือกประเภทเอกสารที่ต้องการก่อนครับ"),
    year: Yup.string().required("ระบุปีการศึกษาด้วยครับ (พ.ศ.)"),
  });

  const onSubmit = (values: { type: string; year: string }) => {
    setKeyStatus("loading");

    switch (values.type) {
      case "mhesi":
        setCurriList(curri.mhesi);
        setLavelList(["ปวช.", "ปวส."]);
        setForm({ type: "อชว.", year: values.year });
        break;

      case "tqf":
        setCurriList(curri.tqf);
        setLavelList(["ป.ตรี", "ป.โท"]);
        setForm({ type: "มคอ.", year: values.year });
        break;
      default:
        setCurriList([]);
        setLavelList([]);
        setForm({ type: "", year: "" });
        break;
    }
    setTimeout(() => {
      setKeyStatus("showData");
    }, 500);
  };
  return (
    <VerifyContext.Provider
      value={{
        keyStatus,
        setKeyStatus,
        form,
        lavelList,
        curriList,
        reCheck,
        setReCheck,
      }}
    >
      <div className="container">
        <h3 className="text-start mt-3">ผลทวนสอบมาตรฐานผลสัมฤทธิ์ของนักศึกษาตามมาตรฐานผลการเรียนรู้</h3>
        <div className="row p-3 mb-4 bg-light rounded-4">
          <div className="row">
            <Formik
              validationSchema={findSchema}
              initialValues={{ type: "tqf", year: "" }}
              onSubmit={onSubmit}
            >
              {({ handleBlur, handleChange, values, errors, touched }) => (
                <Form>
                  <div className="row">
                    <div className="col"></div>
                    <div className="col-md-4 d-flex align-items-center justify-content-end">
                      {/* <select
                        name="type"
                        value={values.type}
                        onChange={(e) => {
                          handleChange(e);
                          setKeyStatus("start");
                          //   setTypeSelect(e.target.value);
                        }}
                        onBlur={handleBlur}
                        placeholder={"ประเภทเอกสาร"}
                        className={`form-select ${touched.type
                          ? errors.type
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                          }`}
                        aria-label="Default select example"
                      >
                        <option selected value="">
                          ประเภทเอกสาร
                        </option>
                        <option value="mhesi">ผลการทวนสอบ อชว.</option>
                        <option value="tqf">ผลการทวนสอบ มคอ.</option>
                      </select> */}
                      {/* <ErrorMessage
                        name="type"
                        className="invalid-feedback"
                        component="div"
                      /> */}
                      <span className="h5">ค้นหาผลการทวนสอบฯ ประจำปีการศึกษา</span>
                    </div>
                    <div className="col-md-2">
                      <Field
                        type="text"
                        value={values.year}
                        onChange={(e: string) => {
                          handleChange(e);
                          setKeyStatus("start");
                          //   setShowData(false);
                        }}
                        className={`form-control ${touched.year
                          ? errors.year
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                          }`}
                        name="year"
                        placeholder="ปีการศึกษา"
                      />
                      <ErrorMessage
                        name="year"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>

                    <div className="col-md-2">
                      <button className="btn btn-success col-12" type="submit">
                        ค้นหา
                      </button>
                    </div>
                    <div className="col"></div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <hr />

        {/* //   กรณีเพิ่งเปิดเข้ามาและกำลังเลือกข้อมูล   // */}
        {keyStatus === "start" && (
          <div className="row alert alert-warning" role="alert">
            <h3>เลือกข้อมูลที่ต้องการแล้วกด ค้นหา</h3>
          </div>
        )}

        {/* //   กรณีกำลัง load ข้อมูล   // */}
        {keyStatus === "loading" && (
          <div className="row alert alert-warning" role="alert">
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status"></div>
              <h3 className="ms-2"> Loading...</h3>
            </div>
          </div>
        )}

        {keyStatus === "showData" && <DataVerify />}
      </div>
    </VerifyContext.Provider>
  );
};
export { VerifyContext };
export default Verify;
